import update from 'immutability-helper';

export default function setFeedData(state, action) {
  // console.log('SET_FEED_DATA', action)

  return update(state, {
    feedData: {
      $set: action.data,
    },
    gettingFeed: {
      $set: false,
    },
  });
}
